<template>
    <div ref="renderJSON"></div>
</template>

<script>
const renderJSON = require('renderjson');

export default {
    name: 'RenderJson',

    props: [
        'jsonString',
    ],

    created() {
        renderJSON.set_show_by_default(true);
    },

    mounted() {
        this.$refs.renderJSON.appendChild(renderJSON(JSON.parse(this.jsonString)));
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/RenderJson.vue